<template>
  <div>

    <div class="ceiling">
      <HomeTop></HomeTop>
      <top-search :showHot="true" type="home" @changeOrder="changeOrder"></top-search>
      <!-- 头部导航栏 -->
      <div class="nav-bar mini-width">
        <div class="nav-bar-box w-1400">
          <div class="nav-bar-title">
            <img class="nav-logo" src="../../static/login/list.png" alt="logo">
            导航栏
          </div>
          <div class="nav-links">
          <span v-for="(item, index) in tarBarList" :key="index" class="more-box">
            <router-link @click="navCurrent = index" :class="navCurrent === index
              ? 'custom-link-active router-link'
              : 'custom-link router-link'
              " :to="item.path">
              {{ item.name }}
            </router-link>
          </span>
          </div>
          <vip-status :margin="false"></vip-status>
        </div>
      </div>
    </div>
    <!-- 首页内容 -->
    <div class="index-box mini-width">
      <div class="swiper">
        <el-carousel height="445px">
          <el-carousel-item v-for="(item, index) in bannerList" :key="index" @click.native="goLink(item)">
            <img class="banner-image" :src="item.image"/>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="flex-inner-left hit-cursor" v-loading="loading">
        <div @mouseenter="enterCatelist(item.id, index)" @mouseleave="closeCate"
             v-for="(item, index) in oneCateList"
             :key="item.id" :class="bannerCurrent === index
                ? 'banner-title-active banner-title'
                : 'banner-title'
                ">
          {{ item.name }}
          <img class="arrow-left" src="../../static/index/arrow-left.png" alt=""/>
        </div>
        <el-collapse-transition class="banner-title-hover hit-cursor">
          <div class="banner-title-hover-box" v-show="showOneCateListHover||otherShowCate">
            <div @mouseenter="enterCatelist(item.id, index + 13)" @mouseleave="closeCate"
                 :class="bannerCurrent === index + 13
                    ? 'banner-title-active-hover banner-title'
                    : 'banner-title'
                    " v-for="(item, index) in oneCateListHover" :key="item.id">
              {{ item.name }}
              <img class="arrow-left" src="../../static/index/arrow-left.png" alt=""/>
            </div>
          </div>
        </el-collapse-transition>
      </div>
      <transition name="el-fade-in-linear" v-loading="loading">
        <div class="content-classfily hit-cursor" v-show="showContentClassfily" @mouseenter="enterCate"
             @mouseleave="closeCate">
          <div class="hover" v-for="item in twoCateList" :key="item.id" @click="goShopList(item)">
            {{ item.name }}
          </div>
        </div>
      </transition>
      <div class="login-box-style">
        <login-box @changeOrder="changeOrder"></login-box>
      </div>
    </div>
    <!-- 消息框 -->
    <sendMessage></sendMessage>
    <scoll-list></scoll-list>
    <!--注册登录-->
    <div class="fun-list mini-width">
      <div class="fun-content w-1400">
        <div class="fun-progress-container">
          <div class="fun-list-item hit-cursor" @click="goFun(item, index)" v-for="(item, index) in funList"
               :key="index">
            <div class="fun-item-icon">
              <img :src="require(`@/static/index/funImage/fun-icon-${index}.png`)"/>
            </div>
            <div class="fun-list-item-name">{{ item.name }}</div>

          </div>
          <!-- 箭头连接线 -->
          <div class="fun-arrows">
            <div class="fun-arrow" v-for="(item, index) in funList.slice(0, -1)" :key="`arrow-${index}`">
              <svg width="80" height="20" viewBox="0 0 80 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <!-- 虚线连接 -->
                <path d="M10 10 L70 10" stroke="#ffffff" stroke-width="2" stroke-dasharray="4,4" opacity="0.8"/>
                <!-- 箭头头部 -->
                <path d="M65 5 L70 10 L65 15" stroke="#ffffff" stroke-width="2" fill="none" opacity="0.9"/>
                <!-- 发光效果 -->
                <path d="M10 10 L70 10" stroke="#ffffff" stroke-width="4" stroke-dasharray="4,4" opacity="0.3"
                      filter="blur(1px)"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--商城精选-->
    <shopList></shopList>
    <!-- 优质供应商 -->
    <supplier></supplier>
    <!--    <help :showGZH="showGZH"></help>-->
    <help-better :showGZH="showGZH" @changeOrder="changeOrder"></help-better>
    <home-footer></home-footer>
    <Post_Inquiry :dialogVisible="showInquiry" @close="changeOrder(false)"></Post_Inquiry>

  </div>
</template>
<script>
import TopSearch from "../../components/public/top-search.vue";
import TitleHome from "../../components/Title/title-home.vue";
import HomeTop from "../../components/public/home-top.vue";
import help from "../../components/public/help.vue";
import {getHomeOneCateList} from "@/api/modules/home";
import {getSwiperList} from "@/api/modules/common";
import loginBox from "@/components/public/login-box.vue";
import QuotationAdd from "../../components/addInfo/quotationAdd.vue";
import sendMessage from "@/components/home/sendMessage.vue";
import Post_Inquiry from "../../components/addInfo/post_Inquiry.vue";
import VipStatus from "@/components/vip/vipStatus.vue";
import HelpBetter from "@/components/public/help-better.vue";
import {addLdJsonToHead, removeLdJsonFromHead} from '@/utils/ldJson';


const Supplier = () => import('@/components/home/supplier.vue')
const ScollList = () => import('@/components/home/scollList.vue')
const shopList = () => import('@/components/home/shopList.vue')
const HomeFooter = () => import('../../components/public/home-footer.vue')
export default {
  components: {
    HelpBetter,
    Supplier,
    shopList,
    ScollList,
    VipStatus,
    Post_Inquiry, QuotationAdd, TopSearch, TitleHome, HomeTop, HomeFooter, help, loginBox, sendMessage
  },

  data() {
    return {
      showInquiry: false,
      navCurrent: 0,
      showMoreBox: false,
      tockInner: "",
      tarBarList: [
        {
          name: "首页",
          path: "/",
        },
        {
          name: "试剂商城",
          path: "/shop",
        },
        {
          name: "原料采购专区",
          path: "/purchase",
        },
        {
          name: "原料供应专区",
          path: "/supply",
        },
        {
          name: "化工资讯",
          path: "/ruitian-news",
        },
        {
          name: "关于我们",
          path: "/about-us",
        },
        {
          name: "行业工具",
          path: "/industry-tools",
        },
        {
          name: "来料加工",
          path: "/project-transaction",
        },
        {
          name: "技术项目交易",
          path: "/technology",
        },
      ],
      funList: [
        {
          name: "注册登录",
          path: "/register",
        },
        {
          name: "发布询单",
          path: "/user/purchase/post",
          check: true,
        },
        {
          name: "发布产品",
          path: "/user/supplier/my-project",
          check: true,
        },
        {
          name: "关注公众号",
        },
        {
          name: "精准匹配报价",
        },
        {
          name: "支付成功",
        },
      ],
      activeIndex: 1,
      bannerList: [],

      bannerCurrent: -1,
      // 首页正常展示的标签
      oneCateList: [],
      // 首页hover展示的标签
      oneCateListHover: [],
      // 首页正常展示的标签
      showOneCateListHover: false,
      // 首页hover展示的标签
      showContentClassfily: false,
      // 是否展示其他分类
      otherShowCate: false,
      // 首页二级标签
      twoCateList: [],
      // 聊天socket
      socket: null,
      // 聊天列表
      messageList: [],
      loading: false,
      statisticsInfo: {},
      // 是否聚焦
      isFocus: false,
      page: 1,
      limit: 10,
      totalPage: 0,
      // 聊天加载相关状态
      isLoadingMore: false, // 是否正在加载更多消息
      showLoadingTip: false, // 是否显示加载提示
      stats: '',
      showGZH: false,
      closeTimer: null
    };
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    },
  },
  mounted() {
    const ldData = {
          "@context": "https://schema.org",
          "@type": "Organization",
          "name": "化联网",
          "alternateName": "Chemical-Link",
          "url": "https://www.chemical-link.com",
          "logo": "https://www.chemical-link.com/static/logo.png",
          "description": "化联网是专注化工领域的B2B资源对接平台，聚焦化工原料采购、化学品销售、来料加工对接、技术合作匹配等场景，助力化工企业高效链接全球资源，实现供需精准匹配与交易安全保障。",
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "17333486080",
            "contactType": "客服",
            "email": "service@chemical-link.com"
          },
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "河北省石家庄市裕华区建通街道塔南路39号超达晶彩中心广场F号办公楼",
            "addressLocality": "河北省",
            "addressRegion": "石家庄市",
            "postalCode": "050000",
            "addressCountry": "CN"
          },
          "sameAs": [
            "https://mp.weixin.qq.com/s/C0_Efg7yX3M_V5TMkF9u_A",
            "https://tieba.baidu.com/p/10281556568",
            "深度揭秘：化联网——化工行业的革新引擎 - 化联网撮合平台的文章 - 知乎https://zhuanlan.zhihu.com/p/1981362663012450747",
            "https://www.bilibili.com/opus/1143930265507201025?_unique_id_=8540a6bf-29dc-4a6f-a6a2-d371f9b3eedd&code=011TPZ1w3AKj663Fd01w3yD22j4TPZ1B&state="

          ]
        }
    ;
    const productLdData = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "化联网化工B2B平台",
      "brand": {
        "@type": "Organization",
        "name": "化联网"
      },
      "description": "化联网平台覆盖精细化工、工业化学品、食品添加剂、化工设备等全品类资源，提供智能供需匹配、企业资质核验、交易流程跟踪、行业资讯推送等核心服务，支持免费发布采购/销售需求，帮助化工企业降低对接成本、提升交易效率。",
      "category": "化工B2B服务平台",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "CNY",
        "availability": "https://schema.org/InStock",
        "url": "https://www.chemical-link.com/register"
      },
      "image": "https://www.chemical-link.com/static/banner.png",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "1200+"
      }
    }
    addLdJsonToHead(ldData, 'org-ld-json');
    addLdJsonToHead(productLdData, 'product-ld-json');
  },
  beforeRouteLeave(to, from, next) {
    removeLdJsonFromHead('org-ld-json');
    removeLdJsonFromHead('product-ld-json');
    next();
  },
  created() {
    // 获取轮播图
    this.getBanner();
    this.init();
  },
  methods: {
    goLink(item) {
      console.log(item.type)
      if (item.type == 3) {
        window.open(item.link, '_blank')
      } else if (item.type == 2) {
        this.$router.push({
          path: "/ruitian/swiper-detail",
          query: {
            id: item.id,
          },
        });
      } else if (item.type == 4) {
        window.open('weixin://launchapplet/?app_id=' + item.appid)
      }
    },
    // 鼠标进入的时候
    enterCatelist(id, index) {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      this.showOneCateListHover = true
      this.showContentClassfily = true
      this.getCate(id, index)
    },

    changeOrder(e) {
      this.showInquiry = e
    },
    goShopList(item) {
      this.$router.push({
        path: "/shop/list",
        query: {
          id: item.id,
          name: item.name,
        },
      });
    },

    goFun(item, index) {
      if (index === 0) {
        this.$router.push(item.path);
        return;
      }
      if (index === 3) {
        this.showGZH = this.showGZH ? false : true
      }
      if (!this.isLogin) {
        this.$confirm("请先登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push("/login");
        });
      } else {
        // 2026-01-10 修改注册流程
        if (item.path) {
          if(item.path == '/user/purchase/post' || item.path == '/user/supplier/my-project'){
            this.$router.push(item.path);
          }else{
            if (item.check && this.mixCheckUserAudit()) {
              this.$router.push(item.path);
            }
          }
        }
      }
    },


    async init() {
      this.$store.dispatch('getDictValuesByKeyFun')
      // 获取首页一级分类（使用缓存，缓存30分钟）
      let res = await getHomeOneCateList({}, true, 1800);
      if (res.data.code === 10000) {
        if (res.data.data.length > 13) {
          this.oneCateList = res.data.data.slice(0, 13);
          this.oneCateListHover = res.data.data.slice(13);
        } else {
          this.oneCateList = res.data.data;
          this.oneCateListHover = [];
        }
      }
    },

    // 获取轮播图
    async getBanner() {
      let res = await getSwiperList(1, true, 1800);
      this.bannerList = res.data.data;
    },

    // 获取二级分类
    async getCate(id, index) {
      this.loading = true;
      this.bannerCurrent = index;
      this.showOneCateListHover = true;
      this.showContentClassfily = true;
      if (index < 13) {
        this.twoCateList = this.oneCateList[index].children;
      } else {
        this.twoCateList = this.oneCateListHover[index - 13].children;
      }

      this.loading = false;
    },
    closeCate() {
      this.closeTimer = setTimeout(() => {
        this.showOneCateListHover = false;
        this.showContentClassfily = false;
        this.closeTimer = null;
      }, 300);
      // this.otherShowCate=false
    },
    enterCate() {
      if (this.closeTimer) {
        clearTimeout(this.closeTimer);
        this.closeTimer = null;
      }
      this.showOneCateListHover = true
      this.showContentClassfily = true
      this.otherShowCate = true
    },
    // showMoreBoxfun() {
    //   this.showMoreBox = !this.showMoreBox;
    // },
  },
};
</script>
<style lang="scss" scoped>
.more-box-dropdown {
  position: absolute;
  z-index: 9999999999;
  background: #fff;
  line-height: 50px;
  box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.5);

  .more-box-dropdown-item {
    padding: 0 20px;
    margin-top: 10px;

    .more-box-dropdown-item-link {
      text-decoration: none;
      color: #333;

      &:hover {
        color: #3860f4;
      }
    }
  }
}

.h-top {
  // height: 275px;
  height: 253px;
}

.nav-bar {
  //height: 60px;
  padding: 10px 0;
  box-sizing: border-box;
  background: #f6f7f8;


  .nav-bar-box {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .nav-bar-title {
      width: 221px;
      font-size: 16px;
      font-weight: bold;
      line-height: 24px;
      color: #FFFFFF;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(135deg, #223bc5 0%, #4facfe 100%);
      padding: 10px 30px;
      box-sizing: border-box;
      border-radius: 10px;

      .nav-logo {
        width: 21px;
        height: 21px;
        margin-right: 10px;
      }
    }
  }

  .nav-links {
    flex: 1;
    display: flex;
    align-items: center;
    padding: 8px 10px;
    justify-content: space-around;
    box-sizing: border-box;
  }

  .more-box {
    cursor: pointer;

    // margin-right: 20px;
    &:last-child {
      margin-right: 0;
    }

    img {
      width: 17px;
      height: 10px;
    }
  }

  .custom-link {
    color: #333333;

    text-align: center;
  }

  .custom-link-active {
    color: #333333;
    text-align: center;
    font-weight: 700;
    color: #4b87ff;
  }
}

.index-box {
  position: relative;
  width: 100%;
  height: 445px;

  .swiper {
    width: 100%;
    height: 100%;

    .banner-image {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  //.flex-inner {
  //  position: absolute;
  //  top: 0;
  //  left: 0;
  //  width: 100%;
  //  height: 100%;
  //  z-index: 90;
  //  display: flex;
  //  justify-content: space-between;

  //.flex-inner-box {
  //  position: absolute;
  //  top: 0;
  //  z-index: 9;
  //  display: flex;
  //  justify-content: space-between;
  //  background: pink;
  //}
  .login-box-style {
    position: absolute;
    top: 0;
    z-index: 9;
    right: calc((100vw - 1200px - 200px) / 2);
  }

  .flex-inner-left {
    position: absolute;
    top: 0;
    z-index: 99;
    left: calc((100vw - 1200px - 200px) / 2);
    width: 221px;
    height: 100%;
    background: rgba(0, 27, 70, 0.5);
    border: 1px solid #e5e5e5;
    padding: 16px 0;
    box-sizing: border-box;
    overflow: hidden;

    &:hover {
      overflow: visible !important;
    }

    .banner-title-hover {
      width: 221px !important;
      position: absolute !important;
      z-index: 999 !important;
      top: 0;
      left: 0;
    }

    .banner-title-hover-box {
      background: rgba(0, 27, 70, 0.8);

      .banner-title-active-hover {
        background: linear-gradient(90deg,
            #246dff 0%,
            #568fff 100%) !important;
        border: 1px solid #2979f1;
      }
    }

    .banner-title {
      line-height: 30px;
      height: 30px;
      padding: 0 30px;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid transparent;

      .arrow-left {
        width: 8px;
        height: 15px;
      }
    }

    .banner-title-active {
      background: linear-gradient(90deg, #246dff 0%, #568fff 100%);
      border: 1px solid #2979f1;
    }
  }

  .content-classfily {
    width: 221px;
    position: absolute;
    left: calc((100vw - 1200px - 200px) / 2);
    top: 0;
    height: 100%;
    // border-radius: 10px;
    background: rgba(0, 27, 70, 0.5);
    color: #ffffff;
    line-height: 30px;
    margin: 0 0 0 221px;
    padding: 16px 0;
    box-sizing: border-box;
    z-index: 99;

    .hover {
      padding: 0 16px;

      &:hover {
        background: linear-gradient(90deg, #246dff 0%, #568fff 100%);
        border: 1px solid #2979f1;
      }
    }
  }

  //}
}


.fun-list {
  height: 180px;
  background-image: url("../../static/index/line.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
  overflow: hidden;

  .fun-content {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #ffffff;
    padding: 40px 0;
    height: 100%;
    box-sizing: border-box;

    .fun-progress-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;
      width: 100%;
      // max-width: 1000px;
    }

    .fun-list-item {
      width: 120px;
      height: 120px;
      position: relative;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: rgba(255, 255, 255, 0.1);
      border-radius: 50%;
      border: 2px solid rgba(255, 255, 255, 0.3);
      transition: all 0.3s ease;
      margin: 0 20px;
      backdrop-filter: blur(10px);
      box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);

      &:hover {
        transform: translateY(-5px) scale(1.05);
        background: rgba(255, 255, 255, 0.2);
        border-color: rgba(255, 255, 255, 0.6);
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
      }

      &:active {
        transform: translateY(-2px) scale(1.02);
      }

      .fun-item-icon {
        margin-bottom: 8px;
        position: relative;
        z-index: 2;

        img {
          width: 32px;
          height: 32px;
          filter: brightness(0) invert(1);
          transition: all 0.3s ease;
        }
      }

      .fun-list-item-name {
        font-size: 12px;
        font-weight: 500;
        line-height: 1.2;
        margin-bottom: 5px;
        position: relative;
        z-index: 2;
      }

      .fun-item-number {
        position: absolute;
        top: -5px;
        right: -5px;
        width: 24px;
        height: 24px;
        background: linear-gradient(135deg, #ff6b6b 0%, #ee5a52 100%);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 12px;
        font-weight: bold;
        color: #ffffff;
        border: 2px solid #ffffff;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        z-index: 3;
      }

      .fun-progress-indicator {
        position: absolute;
        bottom: -10px;
        left: 50%;
        transform: translateX(-50%);
        z-index: 2;

        .progress-circle {
          svg {
            filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));

            circle:last-child {
              transition: stroke-dashoffset 0.8s ease-in-out;
            }
          }
        }
      }

      // 添加发光效果
      &::before {
        content: '';
        position: absolute;
        top: -2px;
        left: -2px;
        right: -2px;
        bottom: -2px;
        background: linear-gradient(45deg, #ff6b6b, #4ecdc4, #45b7d1, #96ceb4);
        border-radius: 50%;
        z-index: -1;
        opacity: 0;
        transition: opacity 0.3s ease;
        animation: rotate 3s linear infinite;
      }

      &:hover::before {
        opacity: 0.3;
      }
    }

    .fun-arrows {
      position: absolute;
      top: 50%;
      left: 0;
      right: 0;
      transform: translateY(-50%);
      display: flex;
      justify-content: space-between;
      align-items: center;
      pointer-events: none;
      z-index: 1;
      padding: 0 70px;

      .fun-arrow {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 0 5px;
        opacity: 0.7;
        transition: all 0.3s ease;
        animation: arrowPulse 2s ease-in-out infinite;

        &:nth-child(1) {
          animation-delay: 0s;
        }

        &:nth-child(2) {
          animation-delay: 0.5s;
        }

        &:nth-child(3) {
          animation-delay: 1s;
        }

        &:nth-child(4) {
          animation-delay: 1.5s;
        }

        &:hover {
          opacity: 1;
          transform: scale(1.2);
          animation-play-state: paused;
        }

        svg {
          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.3));
          transition: all 0.3s ease;
        }
      }
    }
  }
}

// 添加旋转动画
@keyframes rotate {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

// 箭头脉冲动画
@keyframes arrowPulse {

  0%,
  100% {
    opacity: 0.7;
    transform: scale(1);
  }

  50% {
    opacity: 1;
    transform: scale(1.1);
  }
}

// 响应式设计
@media (max-width: 1200px) {
  .fun-list {
    .fun-content {
      .fun-progress-container {
        max-width: 800px;
      }

      .fun-list-item {
        width: 100px;
        height: 100px;
        margin: 0 15px;

        .fun-item-icon img {
          width: 28px;
          height: 28px;
        }

        .fun-list-item-name {
          font-size: 11px;
        }

        .fun-item-number {
          width: 20px;
          height: 20px;
          font-size: 11px;
        }

        .fun-progress-indicator {
          bottom: -8px;

          .progress-circle svg {
            width: 32px;
            height: 32px;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .fun-list {
    height: 150px;

    .fun-content {
      padding: 20px 0;

      .fun-progress-container {
        max-width: 100%;
        flex-wrap: wrap;
        gap: 20px;
      }

      .fun-list-item {
        width: 80px;
        height: 80px;
        margin: 0 10px;

        .fun-item-icon img {
          width: 24px;
          height: 24px;
        }

        .fun-list-item-name {
          font-size: 10px;
        }

        .fun-item-number {
          width: 18px;
          height: 18px;
          font-size: 10px;
        }

        .fun-progress-indicator {
          bottom: -6px;

          .progress-circle svg {
            width: 28px;
            height: 28px;
          }
        }
      }

      .fun-arrows {
        display: none; // 在移动端隐藏箭头
      }
    }
  }
}


@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}


// 配置信息样式
.config-info-box {
  background: #f8f9fa;
  padding: 20px 0;
  margin: 20px 0;

  .config-info-title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 15px;
  }

  .config-info-content {
    display: flex;
    flex-wrap: wrap;
    gap: 20px;

    .config-item {
      display: flex;
      align-items: center;

      .config-label {
        font-weight: bold;
        color: #666;
        margin-right: 10px;
      }

      .config-value {
        color: #3860f4;
        font-weight: 500;
      }
    }
  }
}
</style>
